import Store from 'types/Store';
import { ConfirmationFormValues } from 'views/CheckInConfirmation/types';

export const getCachedConfirmationFormData = (
  state: Store
): ConfirmationFormValues | undefined =>
  state.checkInConfirmation.cachedConfirmationFormData;
